var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav-back-content"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("\n    mdi-arrow-left\n  ")]),_c('span',[_vm._v(_vm._s(_vm.$t('navBack.text')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }